import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { notification } from "antd";
import screenfull from "screenfull";
import axios from "axios";
import LazyLoad from "react-lazy-load";

import { GlobalContext } from "../../app/providers/GlobalState.jsx";

import ConteudoAvaliacao from "./ConteudoAvaliacao";
import Controlos from "../_Aux/Controlos";
import ControlosSimples from "../_Aux/ControlosSimples";
import Oops from "../../pages/Oops.jsx";
import { iconAvaliacao } from "../../assets/tipoDeConteudos/index.js";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Avaliacao extends Component {
    static contextType = GlobalContext;
    state = {
        nome: "",
        objetivos: "",
        questoes: 0,
        curso: "",
        modulo: "",
        moduloIndex: 0,
        aulaid: 0,
        aula: "",
        aulaIndex: 0,
        fullscreen: false,
        dataHora: "",
        //REDIRECT
        redirect: false,
        redirectLink: "",
        sameUrl: true,
        //NAO DISPONIVEL
        nao_disponivel: false,
        //VALIDAR
        conclusao: false
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        this.context.montarNavbar(false);
        var aulaId = localStorage.getItem("codigo_aula");

        this.setState({
            curso: this.props.match.params.curso,
            aulaid: aulaId
        });

        this.registarEntrada(aulaId);
        this.validarConclusao(aulaId);
    }

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            var aulaId = localStorage.getItem("codigo_aula");

            this.registarEntrada(aulaId);
            this.setState(
                {
                    sameUrl: false
                },
                () =>
                    this.setState({
                        sameUrl: true
                    })
            );
        }
    }

    registarEntrada = aulaid => {
        axios({
            method: "post",
            url: "/api/logs/registar-entrada",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                localStorage.setItem("codigo_entrada", response.data);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    validarConclusao = aulaid => {
        axios({
            method: "get",
            url: "/api/player-trabalho/validar-conclusao",
            params: {
                aulaid
            }
        })
            .then(response => {
                this.setState({
                    conclusao: response.data
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    marcarComoNaoDisponivel = () => {
        this.setState({
            nao_disponivel: true
        });
    };

    render() {
        const {
            nome,
            objetivos,
            questoes,
            curso,
            dataHora,
            //REDIRECT
            redirect,
            redirectLink,
            sameUrl,
            //NAO DISPONIVEL
            nao_disponivel,
            //VALIDAR
            conclusao
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <div className="questionario">
                <div className="player-wrapper">
                    {!nao_disponivel ? (
                        <>
                            <ConteudoAvaliacao
                                marcarComoNaoDisponivel={this.marcarComoNaoDisponivel}
                                carregarInfo={(nome, objetivos, questoes, dataHora) =>
                                    this.setState({ nome, objetivos, questoes, dataHora })
                                }
                            />
                            <Controlos
                                backUrl={localStorage.getItem("player_back_url")}
                                sameUrl={sameUrl}
                                temRating
                                temAnotacoes
                                temMarcador
                                temMensagens
                                temInformacoes
                                nome={nome}
                                objetivos={objetivos}
                                questoes={questoes}
                                icon={iconAvaliacao}
                                conclusao={conclusao}
                                dataHora={dataHora}
                            />
                        </>
                    ) : (
                        <>
                            <div className="container">
                                <div className="bloco-nao-disponivel">
                                    <div className="bloco-info nao-disponivel">
                                        <Oops tem_texto texto={"Conteúdo não disponível"} />
                                    </div>
                                </div>
                            </div>
                            <ControlosSimples />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Avaliacao;
